import React from 'react';

const NewSkillFinderSelectedSkills = (props) => {
    const OnRemoveSkill = (skill) => {
        props.OnRemoveSkill(skill)
    }

    return (
        <div className='selected-items'>
            <div className='selected-items-counter'>{props.SelectedSkills.length} {props.translateText('total_skill_selected')}</div>
            {props.SelectedSkills.map(skill => (
                <span key={skill.id} className="small-chip">
                    {skill.title}
                    <i className="feather-x" onClick={() => OnRemoveSkill(skill)}></i>
                </span>
            ))}
        </div>
    );
};

export default NewSkillFinderSelectedSkills;
